import defaultLayout from './defaultLayout';
import splitLayout from './SplitLayout';

export default { defaultLayout, splitLayout };
